<template>
  <div class="about">
        <Header v-bind:header="header"></Header>  
        <v-container>

          <v-row>
            <MediumHeader v-bind:medheader="subheader1"/>
          </v-row>
          <v-row class="mb-16">
            <ul class="impress-list fa-ul" >
              <li><span class="fa-li"><i style="color: #1765B3;"  class="fas fa-record-vinyl"></i></span>Jazzterdays</li>
              <li><span class="fa-li"><i style="color: #1765B3;" class="fas fa-record-vinyl"></i></span><a href="mailto:Volker.praekelt@mediendeck.de" class="contact text-lowercase">Volker.praekelt@mediendeck.de</a></li>
            </ul>
          </v-row >
          <v-row>
              <MediumHeader v-bind:medheader="subheader2"/>
          </v-row>
          <v-row class="mb-16">

            <ul class="impress-list fa-ul" >
              <li><span class="fa-li"><i style="color: #1765B3;" class="fas fa-record-vinyl"></i></span>Kim Reichert</li>
              <li><span class="fa-li"><i style="color: #1765B3;" class="fas fa-record-vinyl"></i></span><a href="mailto:kimrdot.work@gmail.com" class="contact">kimrdot.work@gmail.com</a></li>
            </ul>
          </v-row>
          <v-row>
              <MediumHeader v-bind:medheader="subheader3"/>
          </v-row>
          <v-row class="mb-16">
            <RunningText v-bind:text="copyright"></RunningText>
          </v-row>
        </v-container>
  </div>
</template>


<script>
import Header from './components/Header.vue'
import MediumHeader from './components/MediumHeader.vue'
import RunningText from './components/RunningText.vue'

export default {
  name: 'Staff',
  components: {
    Header,
    MediumHeader,
    RunningText,
  },
  data() {
      return {
        header: "Impressum",
        subheader1: "Betreiber",
        subheader2: "Layout und Umsetzung",
        items: [
          { text: 'Real-Time', icon: 'mdi-clock' },
          { text: 'Audience', icon: 'mdi-account' },
          { text: 'Conversions', icon: 'mdi-flag' },
        ],
        subheader3: "Copyright",
        copyright: "Alle Inhalte auf diesen Seiten sind, falls nicht anders vermerkt, geistiges Eigentum von Jazzterdays. Alle Rechte vorbehalten, auch die der fotomechanischen Wiedergabe und der Speicherung in elektronischen Medien. Veröffentlichungen in anderen Internet-Präsenzen, auch auszugsweise, nur mit ausdrücklicher Genehmigung von Jazzterdays"

// + "In hac habitasse platea dictumst. Suspendisse vitae est dui. Curabitur at diam sit amet leo feugiat hendrerit scelerisque cursus felis. Nunc maximus nisi quis efficitur porttitor. Curabitur egestas mauris ut nibh laoreet, a porttitor ipsum efficitur. Phasellus tortor nunc, efficitur non nunc nec, eleifend interdum velit. Proin sit amet aliquet elit. In egestas sollicitudin felis, eu convallis orci ullamcorper sit amet."

// + "Mauris mollis accumsan quam ut rutrum. Nulla in elementum sapien. Integer pharetra dictum consequat. Quisque at porta libero. Nulla blandit lacus sed eleifend ornare. Vestibulum finibus imperdiet nulla ac lobortis. Fusce in ante vitae purus efficitur fermentum vel eget sapien. Sed a venenatis ipsum. In a dignissim turpis, sed sodales nisi."

// + "In lobortis mauris erat, id varius libero scelerisque eget. Donec at augue a est tempor pretium id sed enim. Mauris mattis, leo nec ultrices volutpat, lorem est sollicitudin dui, ut auctor nibh enim id massa. Nullam sagittis lorem ut purus luctus, ac blandit justo luctus. Cras feugiat odio dictum, bibendum est et, convallis eros. Phasellus scelerisque neque id fermentum elementum. Ut sodales eu ligula in lacinia. Cras a nunc vel velit blandit ornare. Vestibulum bibendum condimentum semper. Quisque consequat arcu nisl, quis laoreet ligula consequat eu. Mauris imperdiet, est eu maximus egestas, odio risus commodo lectus, quis lobortis felis nibh tincidunt enim. Morbi ut neque at enim dapibus maximus at nec risus. Fusce aliquam, metus a dignissim sagittis, turpis augue ullamcorper dui, at blandit erat arcu quis lacus."
    }
  }
}
</script>

<style lang="scss" global>
  @import url('https://fonts.googleapis.com/css2?family=Fauna+One&display=swap');
  @import '~vuetify/src/styles/settings/_variables.scss';

a.contact {
  color: black;
  text-decoration: none;
  &:hover {
    color: #1765B3;
  }
}
ul.impress-list {
  text-align: left;
  // list-style:none;
  padding-left: 0 ;
  font-size: 1.5rem;

}
</style>
